import { render, staticRenderFns } from "./helpMessages.vue?vue&type=template&id=587af7dd&scoped=true&lang=html&"
import script from "./helpMessages.vue?vue&type=script&lang=js&"
export * from "./helpMessages.vue?vue&type=script&lang=js&"
import style0 from "./helpMessages.vue?vue&type=style&index=0&id=587af7dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587af7dd",
  null
  
)

export default component.exports